import React, { useState, useRef } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane, FaSpinner, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { ref, push } from 'firebase/database';
import { database } from '../firebase/config';
import emailjs from 'emailjs-com';
import './Contact.css';

const EMAILJS_SERVICE_ID = 'service_2o4xw2u';
const EMAILJS_ADMIN_TEMPLATE_ID = 'template_fzgelg2';
const EMAILJS_CLIENT_TEMPLATE_ID = 'template_s6uvrfl';
const EMAILJS_USER_ID = 'P5a1-bhf7FB4niDIA';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: 'maison',
    message: '',
    adresseDepart: '',
    adresseArrivee: '',
    dateDemande: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const formRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (!formData.name.trim()) return "Veuillez entrer votre nom";
    if (!formData.email.trim()) return "Veuillez entrer votre email";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return "Email invalide";
    if (!formData.phone.trim()) return "Veuillez entrer votre téléphone";
    if (!formData.message.trim()) return "Veuillez décrire votre projet";
    return null;
  };

  const getServiceLabel = (service) => {
    switch(service) {
      case 'maison': return ' Déménagement maison';
      case 'bureau': return ' Déménagement bureau';
      case 'meubles': return ' Transport de meubles';
      case 'longue-distance': return ' Transport longue distance';
      default: return service;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      
      const rendezvousRef = ref(database, 'rendezvous/sans_compte');
      const newRdv = await push(rendezvousRef, {
        nom: formData.name,
        email: formData.email,
        telephone: formData.phone,
        typeService: formData.service,
        message: formData.message,
        adresseDepart: formData.adresseDepart || 'Non spécifié',
        adresseArrivee: formData.adresseArrivee || 'Non spécifié',
        dateDemande: new Date().toISOString(),
        statut: 'en attente',
        dateCreation: new Date().toISOString(),
        source: 'formulaire_contact',
        compteClient: false
      });

      
      const adminEmailParams = {
        to_email: 'smtdtrans@gmail.com',
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        service: getServiceLabel(formData.service),
        message: formData.message,
        adresse_depart: formData.adresseDepart || 'Non spécifié',
        adresse_arrivee: formData.adresseArrivee || 'Non spécifié',
        date_demande: new Date().toLocaleDateString('fr-FR'),
        rdv_id: newRdv.key
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_ADMIN_TEMPLATE_ID,
        adminEmailParams,
        EMAILJS_USER_ID
      );
      console.log('✅ Email admin envoyé à smtdtrans@gmail.com');

      
      const clientEmailParams = {
        to_email: formData.email,
        to_name: formData.name,
        service: getServiceLabel(formData.service),
        date_demande: new Date().toLocaleDateString('fr-FR'),
        phone_contact: '07 55 13 40 87',
        email_contact: 'smtdtrans@gmail.com'
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CLIENT_TEMPLATE_ID,
        clientEmailParams,
        EMAILJS_USER_ID
      );
      console.log('✅ Email client envoyé à', formData.email);

      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: 'maison',
        message: '',
        adresseDepart: '',
        adresseArrivee: '',
        dateDemande: ''
      });
      
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
      
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-grid">
          {/* Partie gauche - Informations */}
          <div className="contact-info">
            <span className="section-badge">CONTACT</span>
            <h2 className="contact-title">
              Prêt à déménager ?<br />
              <span className="text-gradient">Parlons de votre projet</span>
            </h2>
            
            <p className="contact-description">
              Contactez-nous pour un devis gratuit et personnalisé. 
              Notre équipe vous répondra sous 24h.
            </p>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon">
                  <FaPhone />
                </div>
                <div>
                  <h4>Téléphone</h4>
                  <p>07 55 13 40 87</p>
                  <small>Lun-Ven: 9h-19h</small>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <FaEnvelope />
                </div>
                <div>
                  <h4>Email</h4>
                  <p>smtdtrans@gmail.com</p>
                  <small>Réponse sous 24h</small>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h4>Adresse</h4>
                  <p>10 Rue de la boulangerie, 93200 Saint-Denis</p>
                  <small>France</small>
                </div>
              </div>
            </div>
          </div>

          
          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="contact-form" ref={formRef}>
              <h3>Demander un devis gratuit</h3>
              
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Votre nom complet *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Votre email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Votre téléphone *"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="adresseDepart"
                    placeholder="Adresse de départ"
                    value={formData.adresseDepart}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="adresseArrivee"
                    placeholder="Adresse d'arrivée"
                    value={formData.adresseArrivee}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="maison"> Déménagement maison</option>
                  <option value="bureau"> Déménagement bureau</option>
                  <option value="meubles"> Transport de meubles</option>
                  <option value="longue-distance"> Transport longue distance</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Décrivez votre projet... (volume, étages, etc.)"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <FaSpinner className="spinner" />
                    Envoi en cours...
                  </>
                ) : (
                  <>
                    <FaPaperPlane className="btn-icon" />
                    Envoyer ma demande
                  </>
                )}
              </button>

              {error && (
                <div className="error-message">
                  <FaExclamationTriangle />
                  {error}
                </div>
              )}

              {isSubmitted && (
                <div className="success-message">
                  <FaCheckCircle />
                  ✅ Votre demande a été envoyée avec succès ! 
                  Nous vous répondrons dans les plus brefs délais.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;